import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import Style from "./style";

import MainHeader from "widget/MainHeader";
import Search from "widget/Search";
import Pagenation from "widget/Pagenation";

import TStyle from "shared/style/tableStyle";
import timestampCalculator from "shared/lib/timestampCalculator";
import useFetch from "shared/model/useFetch";

/**
 * @Desc 실기 결제 내역 Page
 * @Access 결제 내역 Page 권한 확인 필요
 * 사용자관리 ui 참고
 * 유저 IDX, 유저아이디, 유저닉네임, 유저이름, 유저연락처, 대회이름, 참가자격, 실기시험상태, 결제금액, 결제날짜, 결제된 필기시험IDX
 * 
 * 유저아이디가 빠져있습니다.
 * 실기시험상태 completd, pending, registered 3개로 확인되는데 피그마에서는 합격, 불합격 두가지가 존재하는데 다른 조건도 존재하는걸까요?
 * date 속성이 결제 날짜 일까요?
 * 
 */
const TryoutPtPayList = () => {
  const navigate = useNavigate();

  const sizeList = [
    "short",
    "long",
    "long",
    "long",
    "long",
    "expand",
    "long",
    "long",
    "long",
    "long",
  ];
  const tableHeadList = [
    "IDX",
    "아이디",
    "닉네임",
    "이름",
    "연락처",
    "대회 이름",
    "참가자격",
    "실기시험 상태",
    "결제 금액",
    "결제 날짜",
  ];

  const [fetchResult, fetchRequest] = useFetch();
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  const search = searchParams.get("search");

  useEffect(() => {
    let path = `/admin/exam-payment/practical/history?page=${page}`;
    if (search) path += `&search=${search}`;
    fetchRequest("GET", path);
  }, [page, search]);

  return (
    <Style.Wrapper>
      <MainHeader>실기 결제 내역</MainHeader>
      <Search placeholder="연락처에 또는 이름을 입력해주세요" />

      <TStyle.TableDiv>
        <TStyle.TableRow $title>
          {tableHeadList.map((elem, index) => (
            <TStyle.Data $title $size={sizeList[index]}>
              {elem}
            </TStyle.Data>
          ))}
        </TStyle.TableRow>
        {fetchResult?.data?.practical_test_payment_history?.map((elem, index) => (
          <TStyle.TableRow $odd={index % 2 === 1}>
            <TStyle.Data $size={sizeList[0]}>{elem?.account_idx}</TStyle.Data>
            <TStyle.Data $size={sizeList[1]} onClick={() => navigate(`/user/${elem?.account_idx}/detail`)}>{elem?.userid}</TStyle.Data>
            <TStyle.Data $size={sizeList[2]}>{elem?.user_nickname}</TStyle.Data>
            <TStyle.Data $size={sizeList[3]}>{elem?.user_name}</TStyle.Data>
            <TStyle.Data $size={sizeList[4]}>+{elem?.international_number} {elem?.phone}</TStyle.Data>
            <Style.Data $size={sizeList[5]}>{elem?.test_name}</Style.Data>
            <TStyle.Data $size={sizeList[6]}>{elem?.test_permission_pro ?? "없음"}</TStyle.Data>
            <TStyle.Data $size={sizeList[7]}>
                {elem?.pass_status === "passed" && "합격"}
                {elem?.pass_status === "failed" && "불합격"}
                {elem?.pass_status === "pending" && "결제완료"}
                </TStyle.Data>
            <TStyle.Data $size={sizeList[8]}>{elem?.amount.toLocaleString()}</TStyle.Data>
            <TStyle.Data $size={sizeList[9]}>{timestampCalculator(elem?.date)}</TStyle.Data>
          </TStyle.TableRow>
        ))}
      </TStyle.TableDiv>

      <Pagenation maxPage={fetchResult?.data?.max_page} />
    </Style.Wrapper>
  );
};

export default TryoutPtPayList;
